class FacilitySlider {

    constructor(){
        this.sliders = document.querySelectorAll(".facility-slider")

        this.lightbox = document.querySelector(".facility-lightbox")
        this.lightboxTrack = document.querySelector(".lightbox-track")
        this.lightboxClose = document.querySelector(".lightbox-close")
        this.lightboxPrev = document.querySelector(".lightbox-prev")
        this.lightboxNext = document.querySelector(".lightbox-next")

        this.lightboxIndex = 0
        this.lightboxTotal = 0

        this.init()
        this.initLightbox()
    }

    init(){

        this.sliders.forEach(slider => {

            const track = slider.querySelector(".slider-track")
            const slides = slider.querySelectorAll(".slide")

            const prevBtn = slider.querySelector(".prev")
            const nextBtn = slider.querySelector(".next")
            const dots = slider.querySelectorAll('[aria-label^="Go to slide"]')

            let index = 0
            const total = slides.length

            const updateSlider = () => {

                track.style.transform = `translateX(-${index * 100}%)`

                dots.forEach((dot, i) => {

                    dot.classList.remove("bg-white")
                    dot.classList.add("bg-white/50")

                    if(i === index){
                        dot.classList.remove("bg-white/50")
                        dot.classList.add("bg-white")
                    }

                })
            }

            nextBtn.addEventListener("click", () => {
                index = (index + 1) % total
                updateSlider()
            })

            prevBtn.addEventListener("click", () => {
                index = (index - 1 + total) % total
                updateSlider()
            })

            dots.forEach((dot, i) => {

                dot.addEventListener("click", () => {
                    index = i
                    updateSlider()
                })

            })

        })

    }


    initLightbox(){

        const images = document.querySelectorAll(".facility-image")

        images.forEach((img) => {

            img.addEventListener("click", () => {

                const slider = img.closest(".facility-slider")
                const sliderImages = slider.querySelectorAll(".facility-image")

                this.buildLightbox(sliderImages)

                const index = [...sliderImages].indexOf(img)

                this.openLightbox(index)

            })

        })

        this.lightboxNext.addEventListener("click", () => {

            this.lightboxIndex = (this.lightboxIndex + 1) % this.lightboxTotal
            this.updateLightbox()

        })

        this.lightboxPrev.addEventListener("click", () => {

            this.lightboxIndex = (this.lightboxIndex - 1 + this.lightboxTotal) % this.lightboxTotal
            this.updateLightbox()

        })

        this.lightboxClose.addEventListener("click", () => {
            this.closeLightbox()
        })

        document.querySelector(".lightbox-overlay").addEventListener("click", () => {
            this.closeLightbox()
        })

        // keyboard navigation
        document.addEventListener("keydown", (e) => {

            if(this.lightbox.classList.contains("hidden")) return

            if(e.key === "ArrowRight") this.lightboxNext.click()
            if(e.key === "ArrowLeft") this.lightboxPrev.click()
            if(e.key === "Escape") this.closeLightbox()

        })

    }


    buildLightbox(images){

        this.lightboxTrack.innerHTML = ""

        images.forEach((img) => {

            const slide = document.createElement("div")

            slide.classList.add(
                "flex-[0_0_100%]",
                "flex",
                "items-center",
                "justify-center",
                "p-4"
            )

            slide.innerHTML = `
                <img src="${img.src}" class="max-w-full max-h-[85vh] object-contain rounded-lg">
            `

            this.lightboxTrack.appendChild(slide)

        })

        this.lightboxTotal = images.length

    }


    openLightbox(index){

        this.lightboxIndex = index

        this.lightbox.classList.remove("hidden")

        this.updateLightbox()

        // disable page scroll
        document.body.classList.add("overflow-hidden")
        document.documentElement.classList.add("overflow-hidden")

    }


    closeLightbox(){

        this.lightbox.classList.add("hidden")
         // enable page scroll
        document.body.classList.remove("overflow-hidden")
        document.documentElement.classList.remove("overflow-hidden")

    }


    updateLightbox(){

        this.lightboxTrack.style.transform = `translateX(-${this.lightboxIndex * 100}%)`

    }

}

export default FacilitySlider